module.exports = __webpack_public_path__ + "img/intro4.7c5fb073.gif";